module.exports = __webpack_public_path__ + "img/ticket-01.0c58c0a1.svg";